/**
 * Zzzing Admin API
 * Zzzing Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GuestyEventEntityType } from './guestyEventEntityType';
import { GuestyEventStatus } from './guestyEventStatus';


export interface GuestyEvent { 
    id?: string;
    guesty_event_id?: string;
    guesty_message_id?: string;
    entity_type?: GuestyEventEntityType;
    /**
     * The ID of the Guesty entity the event refers to
     */
    entity_id?: string;
    event_type?: string;
    status?: GuestyEventStatus;
    /**
     * When the event was received from Guesty
     */
    timestamp?: string;
    /**
     * The number of times the connector attempted to process the event
     */
    attempt_count?: number;
    /**
     * When the event was last processed
     */
    last_attempt_timestamp?: string;
    /**
     * The class of the exception that caused the last attempt to fail
     */
    error_type?: string;
    /**
     * The message of the root cause of the last failure
     */
    error_message?: string;
    /**
     * The stack trace of the last failure
     */
    error_detail?: string;
}

